export default {
    approved: $localize `Transaction was approved`,
    decline_general: $localize `General error`,
    decline_expired_card: $localize `Card is expired`,
    decline_suspected_fraud: $localize `Declined due to suspected fraud`,
    decline_restricted_card: $localize `Card is in restricted list`,
    decline_invalid_card_number: $localize `Declined due to invalid card number`,
    decline_not_sufficient_funds: $localize `Declined due to insufficient funds`,
    decline_card_not_effective: $localize `Card is not active`,
    check_with_acquirer: $localize `Details should be checked with the acquirer`,
}